const DEFAULT_BACKEND_URL = "http://localhost:8001";

const normalizeBackendUrl = (url) => {
  if (!url || !url.trim()) {
    return DEFAULT_BACKEND_URL;
  }

  return url.trim().replace(/\/+$/, "");
};

export const BACKEND_URL = normalizeBackendUrl(process.env.REACT_APP_BACKEND_URL);
export const API_BASE_URL = `${BACKEND_URL}/api`;

export default API_BASE_URL;
